// extracted by mini-css-extract-plugin
export var columnList = "_ct-0";